module.exports = __webpack_public_path__ + "img/matic.71eae707.svg";